import React, { useContext, useState } from "react";
import {
  Button,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
  TableToolbar,
  TableToolbarContent,
} from "carbon-components-react";

import FinancialDataUpdateModal from "underwriter_dashboard/hurdle_editors/FinancialReporting/FinancialDataUpdateModal";
import { FinancialDataContext } from "../FinancialDataProvider";
import Money from "../../../../Money";

const styles = require("./styles.module.scss");

const FinancialDataDisplay = () => {
  const {
    financialData: {
      prepaid_interest,
      secondary_market_accrued_interest,
      sales_adjustments_and_or_penalties,
      interest_income,
      origination_proceeds,
      other_revenue,
      curtailments,
      additional_fees,
      hedging_gains,
    },
  } = useContext(FinancialDataContext);

  const [modalIsOpen, setModalIsOpen] = useState(false);

  return (
    <>
      {modalIsOpen && (
        <FinancialDataUpdateModal
          onClose={() => {
            setModalIsOpen(false);
          }}
        />
      )}
      <div className={styles.container}>
        <TableToolbar>
          <TableToolbarContent>
            <Button onClick={() => setModalIsOpen(true)}>Edit</Button>
          </TableToolbarContent>
        </TableToolbar>
        <Table useZebraStyles>
          <TableHead>
            <TableRow>
              <TableHeader>Type</TableHeader>
              <TableHeader>Amount</TableHeader>
            </TableRow>
          </TableHead>
          <TableBody>
            <TableRow>
              <TableCell>Prepaid Interest</TableCell>
              <TableCell>
                <Money value={prepaid_interest} />
              </TableCell>
            </TableRow>
            <TableRow>
              <TableCell>Secondary Market Accrued Interest</TableCell>
              <TableCell>
                <Money value={secondary_market_accrued_interest} />
              </TableCell>
            </TableRow>
            <TableRow>
              <TableCell>Sales Adjustments And Or Penalties</TableCell>
              <TableCell>
                <Money value={sales_adjustments_and_or_penalties} />
              </TableCell>
            </TableRow>
            <TableRow>
              <TableCell>Interest Income</TableCell>
              <TableCell>
                <Money value={interest_income} />
              </TableCell>
            </TableRow>
            <TableRow>
              <TableCell>Origination Proceeds</TableCell>
              <TableCell>
                <Money value={origination_proceeds} />
              </TableCell>
            </TableRow>
            <TableRow>
              <TableCell>Other Revenue</TableCell>
              <TableCell>
                <Money value={other_revenue} />
              </TableCell>
            </TableRow>
            <TableRow>
              <TableCell>Curtailments</TableCell>
              <TableCell>
                <Money value={curtailments} />
              </TableCell>
            </TableRow>
            <TableRow>
              <TableCell>Additional Fees</TableCell>
              <TableCell>
                <Money value={additional_fees} />
              </TableCell>
            </TableRow>
            <TableRow>
              <TableCell>Hedging Gains</TableCell>
              <TableCell>
                <Money value={hedging_gains} />
              </TableCell>
            </TableRow>
          </TableBody>
        </Table>
      </div>
    </>
  );
};

export default FinancialDataDisplay;
